export enum QueryTimes {
  NONE = 0, // 0 seconds
  HALF_MINUTE = 1000 * 30, // 30 seconds
  SMALLEST = 1000 * 60 * 1, // 1 minute
  SMALL = 1000 * 60 * 3, // 3 minutes
  NORMAL = 1000 * 60 * 5, // 5 minutes
  LONG = 1000 * 60 * 10, // 10 minutes
  LONGEST = 1000 * 60 * 30, // 30 minutes
  INFINITY = Infinity, // Infinity
}
